const STYLES = {
  pending: "border-amber-500/30 bg-amber-500/10 text-amber-400",
  approved: "border-emerald-500/30 bg-emerald-500/10 text-emerald-400",
  published: "border-emerald-500/30 bg-emerald-500/10 text-emerald-400",
  completed: "border-emerald-500/30 bg-emerald-500/10 text-emerald-400",
  rejected: "border-red-500/30 bg-red-500/10 text-red-400",
  new: "border-blue-500/30 bg-blue-500/10 text-blue-400",
  not_submitted: "border-slate-500/30 bg-slate-500/10 text-slate-400",
  handled: "border-slate-500/30 bg-slate-500/10 text-slate-400",
};

export default function StatusBadge({ status, testId }) {
  return (
    <span className={`inline-flex rounded-full border px-2.5 py-0.5 font-mono text-[11px] uppercase tracking-wider ${STYLES[status] || STYLES.handled}`} data-testid={testId}>
      {status?.replace("_", " ")}    </span>
  );
}
